import React, { useCallback } from 'react'

import { number, string } from 'prop-types'

import CheckoutInfoCard from 'Pods/Shared/CheckoutInfoCard/CheckoutInfoCard'
import I18n from 'Pods/Shared/I18n'

import formatPrice from 'Utils/formatPrice'

function SubscriptionTerms({ monthlyPrice, locale = 'en', planKey = null }) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )

  // Essentials (yearly) and Premium share one annual terms block; only monthly differs.
  const termsKey = planKey === 'monthly' ? 'monthly' : 'annual'

  const title = planKey
    ? translate(`subscription_checkout.terms.${termsKey}.title`)
    : translate('subscription_checkout.terms.title')

  const legacyBody = () => (
    `${translate('subscription_checkout.terms.body_start', { price: formatPrice(monthlyPrice) })}`
    + `${translate('subscription_checkout.terms.body_end')}`
  )

  const body = planKey
    ? translate(`subscription_checkout.terms.${termsKey}.body`, { price: formatPrice(monthlyPrice) })
    : legacyBody()

  // Body comes from a local i18n bundle (trusted copy, not user-supplied);
  // the existing markup uses dangerouslySetInnerHTML to preserve embedded
  // formatting tags. Keep the same XSS posture as the prior implementation.
  return (
    <CheckoutInfoCard title={title}>
      <p className="subscription-terms__body">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: body }} />
      </p>
    </CheckoutInfoCard>
  )
}

SubscriptionTerms.propTypes = {
  monthlyPrice: number.isRequired,
  locale: string,
  planKey: string,
}

export default SubscriptionTerms
